wbApp.filter('courseTextFlt', function () {
    return function (items, query) {
        if (!query) {
            return items;
        }

        var lowerCaseQuery = query.toLowerCase();

        var filtered = [];
        angular.forEach(items, function (value, key) {

            var courseAbbreviation = (value.courseAbbreviation || '').toLowerCase();
            var subjectName = (value.subjectName || '').toLowerCase();
            var courseName = (value.courseName || '').toLowerCase();
            var compensationGroupName = (value.compensationGroupName || '').toLowerCase();
            var teacherFullName = (value.teacherFullName || '').toLowerCase();
            var scheduleDay = (value.scheduleDay || '').toLowerCase();

            if (courseAbbreviation.includes(lowerCaseQuery) ||
                subjectName.includes(lowerCaseQuery) ||
                courseName.includes(lowerCaseQuery) ||
                compensationGroupName.includes(lowerCaseQuery) ||
                teacherFullName.includes(lowerCaseQuery) ||
                scheduleDay.includes(lowerCaseQuery)) {
                this.push(value);
            }
        }, filtered);

        return filtered;
    }
});
